import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { actionCreators } from "./redux/sagas/clientProfile/clientProfile";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import ClientInfoTable from "./smartComponents/clientInfoTable";
import { useSelector, useDispatch } from "react-redux";

const ClientProfileModule = ({ currentUser }) => {
  const dispatch = useDispatch();
  const { error, haveError, isLoading } = useSelector((state) => state.clientProfileModule);

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(currentUser));
  }, []);
  return (
    <div style={{ minHeight: "80vh" }}>
      {isLoading ? (
        <LoadingAnimation text="Gathering the most recent information" />
      ) : haveError ? (
        <div className="client-info-wrapper">
          <p className="error">
            Oops, we ran into the following error:
            <br />
            <span>{error}</span>
            <br />
            Please try again.
          </p>
        </div>
      ) : (
        <ClientInfoTable />
      )}
    </div>
  );
};

export default ClientProfileModule;
ClientProfileModule.propTypes = {
  isLoading: PropTypes.bool,
  currentUser: PropTypes.object,
  fetchCurrentUser: PropTypes.func,
  haveError: PropTypes.bool,
  error: PropTypes.string
};
